import { CanvasTexture, SRGBColorSpace } from 'three';

export const getLabelContext = (canvas) => canvas.getContext('2d');

export const createLabelTexture = (canvas) => {
  const texture = new CanvasTexture(canvas);
  texture.colorSpace = SRGBColorSpace;
  return texture;
};

export const updateLabelTexture = (texture, value, color, dieType, paint) => {
  if (!texture?.image) return false;
  const key = JSON.stringify([String(value), color, dieType]);
  if (texture.userData.labelKey === key) return false;
  const canvas = texture.image;
  const context = getLabelContext(canvas);
  if (!context) return false;
  paint(context, canvas.width, canvas.height, value, color, dieType);
  texture.userData.labelKey = key;
  texture.needsUpdate = true;
  return true;
};
